export default {
  pageTitle: 'Ajouter des actifs à votre patrimoine',
  pageTopic: 'Connecter votre patrimoine',
  list: {
    or: 'Ou',
    estimate: 'Définir la valeur du bien',
  },
  warning: {
    title: "Impossible d'estimer votre bien",
    content:
      "Un problème technique affecte actuellement notre outil de simulation immobilière, rendant la simulation impossible pour le moment. Nous vous invitons à réessayer ultérieurement ou à définir une valeur personnalisée afin d'ajouter votre bien immobilier malgré cette difficulté.",
  },
  card: {
    title: {
      low: 'Estimation basse',
      average: 'Estimation moyenne',
      high: 'Estimation haute',
      custom: 'Estimation personnalisée',
    },
    salePrice: 'Estimation vendeur',
    squarePrice: 'Prix M2 moyen',
    rentPrice: 'Valeur locative',
    perMonth: '/mois',
    estimationUnavailable: 'Estimation indisponible',
  },
  amountInputLabel: 'Définir une valorisation personnalisée :',
  banner: {
    title: 'Estimez votre bien grâce à notre outil expert :',
    description:
      'Obtenez une vision plus précise de la valeur de votre bien et suivez son évolution au fil du temps.',
    buttonLabel: 'Estimer mon bien',
  },
}
